import React from 'react';
import { NavLink } from "react-router-dom";
// import about from "../../../assets/img/about-us.png";
import about from "../../../assets/img/hero-img.png";
import { fadeInUp } from 'react-animations';
import Radium, { StyleRoot } from 'radium';


const styles = {
  fadeInUp: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInUp, 'fadeInUp')
  }

}

const About = () => {
  return (
    <React.Fragment>
      <StyleRoot>
        <section id="about" className="about" style={styles.fadeInUp}>
          <div className="container">
            <div className="content">
              <div className='row vt-center'>
                <div className='col-lg-7'>
                  <div className="content-about">
                    <h3>Who we are?</h3>
                    <h2>Welcome to Taskde!</h2>
                    <p>
                      Discover a diverse marketplace where sellers and buyers come together to fulfill a spectrum of needs. From insightful astrology
                      readings to professional mental health support, cutting-edge digital solutions to transformative healing sessions, and reliable
                      tax services, Taskde is your one-stop destination for holistic and comprehensive assistance.

                      Our platform serves as a bridge, connecting individuals seeking specialized services with experienced professionals passionate about making a positive
                      impact. With a focus on personalized care, secure transactions, and a commitment to excellence, we strive to create a supportive environment where
                      your needs are not just met, but exceeded.
                    </p>
                    <div className="text-center text-lg-start">
                      <NavLink to="/aboutus" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center">
                        <span>Read More</span>
                        <i className="bi bi-arrow-right"></i>
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4'>
                  <div className='mobile-display-align'>
                    <div className='content-img-main text-center'>
                      <div className='content-img'>
                        <img src={about} className="img-fluid" alt="" />
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            {/* <div className="col-lg-6 d-flex align-items-center">
              <img src={about} className="img-fluid" alt="" />
            </div> */}
          </div>
        </section>
      </StyleRoot>
    </React.Fragment>
  )
}

export default About;